export default __webpack_public_path__ + "static/media/vajrada_amethyst_sliver.f27d91dc.png";